module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('h2', {
    staticClass: "Verse-head",
    attrs: {
      "id": "_idParaDest-15"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _vm._v("Dwelling")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Beneath ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the jagged")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("flow of time")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("upwelling springs")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of love")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("push through ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the bitter grief")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of loss")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the broken pieces")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("re-arranged ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("as home.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Beyond")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the loud invasive calls")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of honour, stuff, or work")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the stillness ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of a deeper well")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("takes soundings")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("searching ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("for the heart’s ground")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the music")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of the silent rhythms")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("the dwelling place")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-main"
  }, [_vm._v("of God.")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-new"
  }, [_vm._v("Touching base")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("we’re on our way")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("– that pearl! – ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("and all around")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("the searching eyes")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("are asking ")]), _vm._v(" "), _c('p', {
    staticClass: "Verse-last"
  }, [_vm._v("Why? Why? Why?")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3695ff16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781398400801_EPUB-17.vue
// module id = 108
// module chunks = 0